module.exports = __webpack_public_path__ + "img/armhole front.9cf85be0.png";